var map = {
	"./tu_file_jpeg.svg": "43f2",
	"./tu_file_jpg.svg": "a82a",
	"./tu_file_mov.svg": "2f34",
	"./tu_file_mp4.svg": "9f76",
	"./tu_file_other.svg": "7b2a",
	"./tu_file_pdf.svg": "409a",
	"./tu_file_png.svg": "1756",
	"./tu_file_ppt.svg": "9643",
	"./tu_file_view.svg": "bb9c",
	"./tu_file_xls.svg": "d7c3",
	"./tu_file_xlsx.svg": "dab2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90df";